import ReactDOMServer from 'react-dom/server';

const getHtmlString = (Component, props) => ReactDOMServer.renderToString(<Component {...props}/>)

export default getHtmlString